'use client';

import { ReactNode, useContext, useMemo } from 'react';

import { LabelContext, LabelContextValue } from './context';

type LabelProviderProps = {
    children: ReactNode;
    labels: Record<string, string | undefined | null>;
};

export function LabelProvider({ children, labels }: LabelProviderProps) {
    const parentContext = useContext(LabelContext);

    const contextValue = useMemo<LabelContextValue>(
        () => ({
            ...parentContext,
            ...labels,
        }),
        [parentContext, labels]
    );

    return (
        <LabelContext.Provider value={contextValue}>
            {children}
        </LabelContext.Provider>
    );
}
